export const prepareHrefLang = (lang: string): string => {
    if (lang.includes('-')) {
        return lang.slice(0, lang.indexOf('-')) + lang.slice(lang.indexOf('-')).toUpperCase();
    }
    return lang;
};
